
import { supabase } from '@/integrations/supabase/client';

export const securityLogger = {
  async logSecurityEvent(eventType: string, details?: any): Promise<void> {
    try {
      // Use the new enhanced security logging function
      await supabase.rpc('log_policy_violation', {
        _table_name: 'security_events',
        _operation: eventType,
        _details: details || null
      });
    } catch (error) {
      console.error('Error logging security event:', error);
      // Fallback to direct audit_logs insertion
      try {
        await supabase
          .from('audit_logs')
          .insert({
            action: eventType,
            table_name: 'security_events',
            new_values: details || null
          });
      } catch (fallbackError) {
        console.error('Error with fallback security logging:', fallbackError);
      }
    }
  }
};
